import {
  CostScore,
  SolutionMap,
  SolutionOptionKey,
} from "@labs/shared/types/Solution.ts";
import { FuelSource } from "@labs/shared/types/FuelSource.ts";
import { IntermediateResults } from "@labs/shared/types/AnalyzedPlan.ts";
import { getSolutionValueDecimal } from "./getSolutionValueDecimal.ts";

export const calculateEnergyEfficiency = (
  solutionMap: SolutionMap,
  key: SolutionOptionKey,
  baselineTonsCarbonFromSource: number,
  energyToCarbonConversionFactor: number,
  fuelSource: FuelSource,
): IntermediateResults => {
  const efficiencyImpactDecimal = getSolutionValueDecimal(solutionMap, key);
  const unitsOfEnergy =
    baselineTonsCarbonFromSource / energyToCarbonConversionFactor;
  const unitsOfEnergyAfterReduction =
    unitsOfEnergy * (1 - efficiencyImpactDecimal);
  const unitsOfCarbonAfterReduction =
    unitsOfEnergyAfterReduction * energyToCarbonConversionFactor;
  const carbonImpact =
    unitsOfCarbonAfterReduction - baselineTonsCarbonFromSource;
  const costScore = -carbonImpact * CostScore.One;
  return {
    unitsOfEnergy,
    unitsOfEnergyAfterReduction,
    unitsOfCarbonAfterReduction,
    carbonImpact,
    costScore,
    solutionPercent: efficiencyImpactDecimal * 100,
    fuelImpacts: [
      {
        fuelSource: fuelSource,
        carbonImpact,
      },
    ],
  };
};
